import classNames from "classnames"
import { useCallback } from "react"
import { CreationOverlay } from "./CreationOverlay"
import { Feed } from "./Feed"
import {
  Graph,
  GraphContextProvider,
  TooltipContextProvider,
} from "./Graph"
import styles from "./Home.module.scss"
import { HomeWithNoFollows } from "./HomeWithNoFollows"
import {
  Insights,
  InsightsContextProvider,
} from "./Insights"
import { MultiTabHeader } from "./MultiTabHeader"
import { PumpStatusBar } from "./PumpStatusBar"
import { TabContextProvider } from "./TabContext"
import { UserHeader } from "./UserHeader"
import { useScrollState } from "./useScrollState"
import {
  EntryModal,
  EventModal,
  FavoritesModal,
} from "src/components"
import { useFollowedUsers } from "src/contexts/FollowedUsersContext"
import { EntryTemplateLoadingProvider } from "src/contexts/LoadingContexts"
import { usePumpStatus } from "src/hooks"

function HomeScreen() {
  const {
    feedScrollToDate,
    setFeedScrollToDate,
    graphScrollToDate,
    setGraphScrollToDate,
    updateScrollController,
  } = useScrollState()

  const graphUpdateScrollController = useCallback(
    () => {
      updateScrollController("graph")
    },
    [updateScrollController],
  )

  const feedUpdateScrollController = useCallback(
    () => {
      updateScrollController("feed")
    },
    [updateScrollController],
  )

  const pumpStatus = usePumpStatus()

  return (
    <>
      <UserHeader />
      <EntryTemplateLoadingProvider>
        <EntryModal>
          <EventModal>
            <FavoritesModal>
              <TabContextProvider>
                <InsightsContextProvider>
                  <CreationOverlay>
                    <div
                      className={
                        classNames(
                          styles.container,
                          pumpStatus && styles.containerWithPumpStatusBar,
                        )
                      }
                    >
                      {pumpStatus && (
                        <PumpStatusBar
                          className={styles.pumpStatusBar}
                          pumpStatus={pumpStatus}
                        />
                      )}
                      <GraphContextProvider
                        scrollToDate={graphScrollToDate}
                        setFeedScrollToDate={setFeedScrollToDate}
                      >
                        <TooltipContextProvider>
                          <Graph
                            className={styles.graph}
                            updateScrollController={graphUpdateScrollController}
                          />
                        </TooltipContextProvider>
                      </GraphContextProvider>
                      <MultiTabHeader className={styles.tabs} />
                      <Insights className={styles.insights} />
                      <Feed
                        className={styles.activityList}
                        scrollToDate={feedScrollToDate}
                        setGraphScrollToDate={setGraphScrollToDate}
                        updateScrollController={feedUpdateScrollController}
                      />
                    </div>
                  </CreationOverlay>
                </InsightsContextProvider>
              </TabContextProvider>
            </FavoritesModal>
          </EventModal>
        </EntryModal>
      </EntryTemplateLoadingProvider>
    </>
  )
}

export function Home() {
  const { isFollowOnlyWithNoFollows } = useFollowedUsers()

  if (isFollowOnlyWithNoFollows) {
    return <HomeWithNoFollows />
  }

  return <HomeScreen />
}
